import { missingCapabilities } from '../lib/browserSupport.js';
import { AlertIcon } from '../icons.js';

/**
 * Landing-page advisory, shown only when this browser actually lacks something
 * the app uses. Silent otherwise — a permanent "use Chrome" banner would also be
 * telling Chrome users to use Chrome.
 *
 * The detail line is a LIST, not a sentence, so it reads correctly whether one
 * capability is missing or both ("screen sharing isn't" vs "…and call
 * notifications aren't").
 */
export function BrowserNotice() {
  const missing = missingCapabilities();
  if (missing.length === 0) return null;

  return (
    <div className="notice-warning mb-6">
      <AlertIcon className="shrink-0 mt-0.5" />
      <div>
        <div className="font-medium">
          For the most reliable experience, use Chrome on a laptop or desktop.
        </div>
        <div className="text-[0.9rem] mt-0.5">
          You can still join calls on this device.
        </div>
        <div className="text-[0.9rem] mt-0.5">
          Not available here: {missing.join(', ')}.
        </div>
      </div>
    </div>
  );
}
